// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

import Vue from "vue";

import NProgress from "nprogress";

import NotifyPlugin from "../notifications/index";
import vueApp from "../entrypoints/vueApp";
import { AxiosConfig } from "@js-from-routes/axios";
import httpClient from "../api/httpClient";
import vuetify from "../plugins/vuetify";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import VuePapaParse from "vue-papa-parse";
Vue.use(NotifyPlugin, {
  x: "center",
  y: "top",
  property: "$notify",
  $vuetify: vuetify.framework,
});
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "fa",
});
Vue.use(VuePapaParse);
NProgress.configure({ showSpinner: false });
console.log("Vite ⚡️ Rails");
AxiosConfig.instance = httpClient;

document.addEventListener("DOMContentLoaded", () => {
  vueApp.$mount("#app");
});
